export default "__VITE_PUBLIC_ASSET__58b660f8__"